module.exports = __webpack_public_path__ + "img/3_42.13688339.png";